import { getElement } from '../Utility/Dom'

class TopButton {
  private readonly button: HTMLElement | null = null

  constructor() {
    this.button = getElement('top-button')
  }

  public init(): void {
    if (this.button === null) return

    this.addEvents()
  }

  private addEvents(): void {
    this.button.addEventListener('click', (e): void => {
      e.preventDefault()

      document.body.scrollTop = 0 // Safari
      document.documentElement.scrollTop = 0
    })
  }
}

const topButton = new TopButton()
topButton.init()
